<template>
	<!-- {{langtrans().dhtzzz[languageIndex]}}bug -->
	<div class="case_wrap">
		<el-container v-if='this.$route.query.typeId != undefined'>
			<el-aside width="250px">
				<el-menu default-active="/mainPase" router>
					<p @click="pathFun" class="b_index">{{langtrans().fhsy[languageIndex]}}</p>
					<div class="nav_box">
						<router-link class="up" :to="{name:'Await',params:{token:token},query:{typeId:typeId}}" :title='typeNameEn'>
							<template v-if="languageIndex == 0">{{typeName}}</template>
							<template v-if="languageIndex == 1">{{typeNameEn}}</template>
							{{langtrans().gl[languageIndex]}}
						</router-link>
						<router-link class="ha" :class='{active:routerShow1 || routerShow5}' :to="{name:'Await',params:{token:token},query:{typeId:typeId}}">{{langtrans().dddfab[languageIndex]}}</router-link>
						<router-link class="ha" v-if="typeId != 800" :class='{active:routerShow2 || routerShow6}' :to="{name:'Offer',params:{token:token},query:{typeId:typeId}}">{{langtrans().dddsqz[languageIndex]}}</router-link>
						<router-link class="ha" :class='{active:routerShow3}' :to="{name:'Rescue',params:{token:token},query:{typeId:typeId}}">{{langtrans().jyzzaj[languageIndex]}}</router-link>
						<router-link class="ha" :class='{active:routerShow4}' :to="{name:'Finish1',params:{token:token},query:{typeId:typeId}}">{{langtrans().ywcaj[languageIndex]}}</router-link>
					</div>
					<router-link class="ha close" :to="{name:'Close',params:{token:token},query:{typeId:typeId}}">{{langtrans().bjjjyg[languageIndex]}}</router-link>
				</el-menu>
			</el-aside>
			<el-main>
				<router-view></router-view>
			</el-main>
		</el-container>
		
		<el-container v-else>
			<el-aside width="250px">
				<el-menu default-active="/commonPage" router>
					<!--<router-link :to="{name:indexArray[usertype],params:{token:token}}" class="b_index">{{langtrans().fhsy[languageIndex]}}</router-link>-->
					<p @click="pathFun" class="b_index">{{langtrans().fhsy[languageIndex]}}</p>
					<div class="nav_box">
						<a>{{langtrans().ajgl[languageIndex]}}</a>
						<router-link class="ha active" :to="{name:finishArray[usertype],params:{token:token}}">{{langtrans().ywcjya[languageIndex]}}</router-link>
					</div>
				</el-menu>
			</el-aside>
			<el-main>
				<router-view></router-view>
			</el-main>
		</el-container>		
	</div>
</template>

<script>
import langtrans from "./js/Caseindex.vue.trans.js";
	import "isomorphic-fetch";
	import constants from "@/util/constants.js";
	import Promise from "promise-polyfill";

	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		data() {
			return {
				token: this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data,
				insti: this.$route.params.insti ||
					JSON.parse(window.localStorage.getItem("insti")),
				typeId: this.$route.query.typeId,
				typeName: "",
				typeNameEn: "",
				routerShow1:false,
				routerShow2:false,
				routerShow3:false,
				routerShow4:false,
				routerShow5:false,
				routerShow6:false,
				
				usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
				finishArray: ["Finish1", "ComFinish", "RegFinish"],
				indexArray: ["FacIndex", "ComIndex", "RegIndex"]
			};
		},
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},		
		methods: {
			langtrans(){
				return langtrans
			},			
			pathFun(){
				this.$router.push({name:'mainPase'})
			}
		},
		mounted() {
			let that = this;
			if(this.$route.query.typeId != undefined){
				fetch(constants.domain + "rescue/service_plan/get_service", {
						method: "POST",
						body: `token=${this.token || JSON.parse(window.localStorage.getItem("data")).data}&id=${this.typeId}`,
						mode: "cors",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					})
					.then(function(res) {
						return res.json();
					})
					.then(function(data) {
						if(data.code == 0) {
							that.typeName = data.obj.name;
							that.typeNameEn = data.obj.nameEn;
						} else {
							console.log("center case index getService error:" + data.code);
						}
					});				
			}else{
				let that = this;
				if(that.usertype == 0) {
					that.routeNameType = "Finish";
				}
				if(that.usertype == 2) {
					that.routeNameType = "RegFinish";
				}
			}
				var router=this.$route.name;
				this.routerShow1=false;
				this.routerShow2=false;
				this.routerShow3=false;
				this.routerShow4=false;
				this.routerShow5=false;
				this.routerShow6=false;				
				if(router == 'parinf'){
					this.routerShow1=true;
				} else if(router == 'lookinf'){
					this.routerShow2=true;
				}else if(router == 'resstep'){
					this.routerShow3=true;
				}else if(router == 'Finishparinf'){
					this.routerShow4=true;
				}else if(router == 'Inf'){
					this.routerShow5=true;
				}else if(router == 'alter'){
					this.routerShow6=true;
				}
		},
		updated() {
			this.typeId = this.$route.query.typeId;
			this.name = this.$route.query.name;
		},
		watch:{
			$route(to){
				var router=to.name;
				this.routerShow1=false;
				this.routerShow2=false;
				this.routerShow3=false;
				this.routerShow4=false;
				this.routerShow5=false;
				this.routerShow6=false;				
				if(router == 'parinf'){
					this.routerShow1=true;
				} else if(router == 'lookinf'){
					this.routerShow2=true;
				}else if(router == 'resstep'){
					this.routerShow3=true;
				}else if(router == 'Finishparinf'){
					this.routerShow4=true;
				}else if(router == 'Inf'){
					this.routerShow5=true;
				}else if(router == 'alter'){
					this.routerShow6=true;
				}
				
			}
		}
	};
</script>

<style scoped>
	@import url(../../css/caseindex.css);
	.close {
		background-color: white;
		margin-top: 20px;
	}
	
	.nav_box .active {
		background: #00abfa !important;
		color: #fff;
	}
	.case_wrap{margin-top: 20px;}
	.router-link-active:hover, .active:hover{color: #fff;background: #00abfa}
</style>



// WEBPACK FOOTER //
// src/components/fac/Caseindex.vue